export const connotationPool = [
    {
      word: "youthful",
      connotation: "Positive",
      options: ["Negative", "Neutral"]
    },
    {
      word: "childish",
      connotation: "Negative",
      options: ["Positive", "Neutral"]
    },
    {
      word: "frugal",
      connotation: "Positive",
      options: ["Negative", "Neutral"]
    },
    {
      word: "cheap",
      connotation: "Negative",
      options: ["Positive", "Neutral"]
    }
  ];
  